<template> 
  <div>
    <div class="nav_bar">
        <nav-top-bar></nav-top-bar>
    </div>
    <div class="clear"></div>
      <!-- <side-bar></side-bar> -->
      <div class="main-container">
        <router-view></router-view>
      </div>
      <footer-content></footer-content>
      <div class="videoWrap">
          <!-- <div class="videoImg ImaginAry">
              <a href="http://wpa.qq.com/msgrd?v=3&uin=3503985934&site=qq&menu=yes" target="_blank">
                  <img src="./libv2/images/QQ.png" alt="QQ">
              </a>
          </div> -->
          <div class="videoImg ImaginAry">
              <a href="javascript:;" @click="mark()">
                  <span class="iconfont icon-yuyueyanshi"></span>
                  <p>预约演示</p>
              </a>
          </div>
          <div class="videoImg ImaginAry" style="margin:10px 0;">
              <div class="qrCode-wrap">
                  <img src="../../static/home/QRCodes.png" alt="微信"/>
              </div>
              <a href="javascript:;">
                  <span class="iconfont icon-weixingongzhonghao"></span>
                  <p>微信公众号</p>
              </a>
          </div>
          <div class="videoImg" @click="returnToTop">
              <a href="javascript:;">
                  <span class="iconfont icon-huidingbu"></span>
                  <p>回顶部</p>
              </a>
          </div>
      </div>
  </div>
  
</template>

<script>
import NavTopBar from "@/components/NavTopBar.vue";
import SideBar from "@/components/SideBar.vue";
import BreadcrumbWly from "@/components/BreadcrumbWly.vue";
import FooterContent from "@/components/Footer.vue";
export default {
name: "NavBar",
methods: {
  returnToTop () {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
  },
  mark () {
      window.open('https://jinshuju.net/f/M6hUEl', '_blank');
  }
},
components: {
  NavTopBar,
  SideBar,
  BreadcrumbWly,
  FooterContent
}
};
</script>
<style lang="scss">
.videoWrap {
  /* display: flex;
  justify-content: space-between;
  align-items: center; */
  position: fixed;
  justify-content: space-around;
  width: 80px;
  height: 260px;
  margin-bottom: -130px;
  bottom: 50%;
  right: 10px;
  z-index: 99;
  .videoImg {
    width: 80px;
    height: 80px;
    color: #ffffff;
    text-align: center;
    border-radius: 5px;
    background: #000000;
    transition: all .1s linear;
    span {
      font-size: 20px;
      text-align: center;
    }
    p {
      font-size: 14px;
      text-align: center;
    }
    a {
      height: 80px;
      color: #ffffff;
      text-decoration: none;
      padding-top: 20px;
      box-sizing: border-box;
      display: block;
    }
    .qrCode-wrap {
        position: absolute;
        transform: translate(-110%, -20%);
        transition: all .6s;
        opacity: 0;
        visibility: hidden;
    }
  }
  .videoImg:nth-child(2) {
    position: relative;
  }
  .videoImg:nth-child(2):hover .qrCode-wrap{
    opacity: 1;
    visibility: visible;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue